import {
  AfterViewChecked,
  Component,
  ElementRef,
  Inject,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProduccionService } from 'app/services/produccion.service';

@Component({
  selector: 'app-status-change-modal',
  templateUrl: './status-change-modal.component.html',
  styleUrls: ['./status-change-modal.component.css'],
})
export class StatusChangeModalComponent {
  currentStatus: string;
  availableStatuses: { id: number; name: string }[];
  selectedStatusId: number | null = null;
  ordenId: number;
  showQuantityField = false;
  productionQuantity: number;
  suitableQuantity: number;

  constructor(
    public dialogRef: MatDialogRef<StatusChangeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ordenService: ProduccionService,
    private snackBar: MatSnackBar
  ) {
    this.currentStatus = data.currentStatus;
    this.availableStatuses = data.availableStatuses;
    this.ordenId = data.ordenId;
    this.productionQuantity = data.quantity || 0;
    this.suitableQuantity = this.productionQuantity;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  isFormValid(): boolean {
    if (this.showQuantityField) {
      return (
        this.selectedStatusId !== null &&
        this.suitableQuantity !== undefined &&
        this.suitableQuantity >= 0 &&
        this.suitableQuantity <= this.productionQuantity
      );
    }
    return this.selectedStatusId !== null;
  }

  onStatusChange(): void {
    const selectedStatus = this.availableStatuses.find(
      s => s.id === this.selectedStatusId
    );
    this.showQuantityField =
      selectedStatus?.name?.toUpperCase() === 'LISTO PARA COMERCIALIZAR';
  }

  confirmChange(): void {
    if (!this.isFormValid()) return;

    this.ordenService
      .updateProduccion(this.ordenId, { productionStatusId: this.selectedStatusId })
      .subscribe(
        () => {
          this.snackBar.open('Estado cambiado con éxito', 'Cerrar', { duration: 3000 });
          this.dialogRef.close({
            statusId: this.selectedStatusId,
            suitableQuantity: this.suitableQuantity,
          });
        },
        error => {
          this.snackBar.open(error.message, 'Cerrar', { duration: 3000 });
        }
      );
  }
}
